import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, MapPinIcon, ShoppingBagIcon, XIcon } from 'lucide-react';
const purchases = [['Florencia M.', 'Córdoba, Argentina', 'Combo Completo GAP'], ['Sofía R.', 'Rosario, Argentina', 'Combo GAP + GAP Home Pro'], ['Carla P.', 'Mendoza, Argentina', 'Combo Completo GAP'], ['Julieta A.', 'Buenos Aires, Argentina', 'Combo GAP + GAP Home Pro'], ['Natalia G.', 'Mar del Plata, Argentina', 'Combo Completo GAP']];
export function FloatingElements() {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [number, setNumber] = useState(0);
  const [cta, setCta] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    const delay = number === 0 ? 6000 : 8500;
    const showTimer = window.setTimeout(() => setVisible(true), delay);
    const rotateTimer = window.setTimeout(() => {
      setVisible(false);
      setNumber(value => (value + 1) % purchases.length);
    }, delay + 5500);
    return () => {
      window.clearTimeout(showTimer);
      window.clearTimeout(rotateTimer);
    };
  }, [dismissed, number]);
  useEffect(() => {
    const onScroll = () => setCta(window.scrollY > 600);
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  const [name, city, plan] = purchases[number];
  return <>
    <AnimatePresence data-id="element-187" data-mp="rr10h2vqldlq">{visible && !dismissed && <motion.aside initial={{
        opacity: 0,
        y: 28,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 22,
        scale: 0.96
      }} transition={{
        type: 'spring',
        stiffness: 280,
        damping: 24
      }} className="fixed bottom-4 left-4 z-[60] max-w-[300px] overflow-hidden rounded-2xl border-2 border-gold bg-primary p-3 pr-8 shadow-[0_18px_42px_rgba(157,23,77,.42)]" aria-live="polite" data-id="element-188" data-mp="rppy97hxwdwq">
      <div className="absolute inset-y-0 left-0 w-1.5 bg-gold" data-id="element-189" data-mp="1aik1x5a44jln" />
      <div className="absolute right-0 top-0 h-12 w-12 rounded-bl-full bg-rose-400/20" data-id="element-190" data-mp="36kdqcnblpw5m" />
      <button onClick={() => setDismissed(true)} className="absolute right-1.5 top-1.5 rounded p-1 text-rose-200 transition-colors hover:text-white" aria-label="Cerrar notificación" data-id="element-191" data-mp="32j1x87tiqsso"><XIcon className="h-3.5 w-3.5" data-id="element-192" data-mp="3gbrksgop45rw" /></button>
      <div className="flex gap-3" data-id="element-193" data-mp="3bj85nfad12kz"><span className="rounded-full border-2 border-amber-100 bg-gold p-2 text-white shadow-sm" data-id="element-194" data-mp="3biyfnrpbevfa"><ShoppingBagIcon className="h-5 w-5" data-id="element-195" data-mp="3q7l5woghd7la" /></span><div data-id="element-196" data-mp="3qaqrvuttbtcs"><p className="flex items-center gap-1 text-[10px] font-extrabold uppercase tracking-[.12em] text-gold" data-id="element-197" data-mp="3qah5eh7z84bu"><CheckCircle2Icon className="h-3 w-3" data-id="element-198" data-mp="3lbvzq29ygsg0" /> Compra reciente</p><p className="mt-1 text-xs leading-snug text-rose-50" data-id="element-199" data-mp="32n8cvr3bxxp"><b className="text-white" data-id="element-200" data-mp="3uahgpszs3zeo">{name}</b> adquirió el libro digital <b className="text-rose-200" data-id="element-201" data-mp="3ub0yn9pfinsp">{plan}</b></p><p className="mt-1 flex items-center gap-1 text-[10px] font-medium text-rose-200" data-id="element-202" data-mp="24v1iv9rb2043"><MapPinIcon className="h-3 w-3 text-gold" data-id="element-203" data-mp="24x4i8kecl5lh" />{city} · Argentina · hace {number * 7 + 2} min</p></div></div>
    </motion.aside>}</AnimatePresence>
    <AnimatePresence data-id="element-204" data-mp="ff7ge2u9973l">{cta && <motion.a href="#pricing" initial={{
        y: 80,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} exit={{
        y: 80,
        opacity: 0
      }} className="fixed bottom-3 left-3 right-3 z-50 rounded-2xl bg-primary py-3.5 text-center font-display text-sm font-bold text-white shadow-lg shadow-primary/30 md:hidden" data-id="element-205" data-mp="fexw8vvw5u5t">QUIERO MI COMBO GAP →</motion.a>}</AnimatePresence>
  </>;
}